import { CountryCode } from '@shared/enums/coutry-code';

export const plateConfig = {
  [CountryCode.FR]: {
    code: 'f',
    placeholder: 'AB-123-CD',
  },
  [CountryCode.IT]: {
    code: 'i',
    placeholder: 'AB-123CD',
  },
  [CountryCode.ES]: {
    code: 'e',
    placeholder: '1234-ABC',
  },
  [CountryCode.FI]: {
    code: 'fin',
    placeholder: 'ABC-D23',
  },
};
